<div class="bulb-draggable-block-container bulb-sortable-block-container bulb-sortable-tile-block-container">

  <!-- TODO FUTURE : Add / implement the search bar for the content selection display, something like  -->
  <!-- <content-display-selection-search></content-display-selection-search> -->

  <!-- Breadcrumb trail for selection display if the user is drilling down into collections -->
  <ng-container *ngIf="!renderResumeSubSectionTileView" >
    <bulb-resume-content-selection-breadcrumbs
      [selectedCollection]="selectedCollection"
      [units]="units"
      (onBreadCrumbClick)="handleNavigatingBreadCrumb( $event )">
    </bulb-resume-content-selection-breadcrumbs>
  </ng-container>

  <div class="bulb-block-container-tile"
      [ngClass]="!renderResumeSubSectionTileView ? 'content-selection-display-tile-container' :
                       'resume-sub-section-display-tile-container'">
    <div *ngFor="let unit of units"
       class="bulb-block-draggable-wrapper"
       [ngClass]="{'resume-sub-section-draggable-wrapper' : renderResumeSubSectionTileView }"
       (click)="selectUnit( $event, unit, renderResumeSubSectionTileView )">

      <!-- Separation tab, not needed for the resume sub section view -->
      <div  *ngIf="!renderResumeSubSectionTileView"
          class="bulb-block-drop-order-separation">
        <div class="drag-handle">
          <div class="drag-handle-line"></div>
        </div>
      </div>

      <!-- aero unit tile component to render unit -->
      <aero-unit-tile [editMode]="editMode"
              [unit]="unit"
              [renderedInResumeSubSectionView]="renderResumeSubSectionTileView"
              [imageMetaInfo]="unit.image"
              [selectionMode]="selectionMode"
              (onCollectionSelect)="selectUnit( $event, unit, renderResumeSubSectionTileView )"
              (onUnitRemoval)="handleRemovalOfPortfolioContent($event)">
      </aero-unit-tile>
    </div>
  </div>

</div>
